import React, { useState, useEffect } from "react";
import { useDispatch, useSelector  } from "react-redux";
import { useLocation } from "react-router-dom";
import queryString from 'query-string'
import { setPageClass, setUpHeader } from "../../store/features/slice-ui";
import { register, registerValidate } from "../../store/features/slice-account";
import { resetErrors } from "../../store/features/slice-api";
import Link from "../../components/Link";
import PageHead from "../../components/PageHead";
import PageContent from "../../components/PageContent";
import Input from "../../components/Form/Input";
import Checkbox from "../../components/Form/Checkbox";
import InputPhone from "../../components/Form/Phone";
import Button from "../../components/Button";
import {Word} from "../../components/Word";
import Step from "../../components/Step";
import Select from "../../components/Form/Select";
import G from "../../app/globals";
import { ReactComponent as CloseIcon } from '../../assets/images/icons/close_circle.svg';


const RegisterForm = (props) => {
  const dispatch = useDispatch();
  const topics = useSelector((state) => state.references.topics);
  const specialities = useSelector((state) => state.references.specialities);
  const errors = useSelector((state) => state.api.errors.register);
  const totalSteps = 5;
  const { search } = useLocation()
  const queryParams = queryString.parse(search);

  useEffect(() => {
    dispatch(setPageClass("page-register no-bottom-menu"));
    dispatch(setUpHeader({
      logo: true
    }));
  },[dispatch]);

  const initialFormState = {
    _first_name: props.location.state?._first_name || queryParams?._first_name ||  "",
    _last_name: props.location.state?._last_name || queryParams?._last_name || "",
    _email: props.location.state?._email || queryParams?._email || "",
    _mobile_number: queryParams?._mobile || "",
    _postcode: queryParams?._postcode || "",
    _pass: "",
    _salutation: props.location.state?._salutation || "",
    _speciality: "",
    _sub_specialities: "",
    _racgp_number: props.location.state?._racgp_number || "",
    _ahpra_number: "",
    _clinics: [
      {
        name: "",
        address: "",
        email: "",
        provider_number: ""
      }
    ],
    _topics: [],
    _marketing: [],
    _event_id: props.location.state?._event_id || "",

  };
  const [form, setForm] = useState(initialFormState);
  const [currentStep, setCurrentStep] = useState(1);
  const [subSpecialities, setSubSpecialities] = useState([]);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });

    if(e.target.name === '_pass'){
      const isWeakPassword = G.WEAK_PASSWORDS.includes(e.target.value);
      e.target.setCustomValidity(e.target.validity.patternMismatch ? 'Password must contain at least 8 characters.' : '');
      if (isWeakPassword) {
        e.target.setCustomValidity('This password is weak and widely used. Please choose a stronger one.');
      }
    }
    if(e.target.name === '_ahpra_number'){
      e.target.setCustomValidity(e.target.validity.patternMismatch ? 'AHPRA number must start with 3 letters followed by 10 numbers.' : '');
    }
  };
  const handleSelectChange = (source, payload, isMulti) => {
    setForm({
        ...form,
        [source]: isMulti ? payload.map(item => item.value) : payload.value
    });
  };

  const handleSpecialityChange = (payload) => {
    setForm({
      ...form,
      '_speciality': payload.value,
      '_sub_specialities': '',
    });
    if(payload.children && payload.children.length > 0){
      setSubSpecialities(payload.children);
    }
  };

  const handleChangeClinic = (e, index) =>{
    setForm({
      ...form,
      '_clinics': form._clinics.map((clinic, i) => index === i ? {...clinic, [e.target.name] : e.target.value} : clinic)
    });
  } 

  const handleAddClinic = () => {
    setForm({
      ...form,
      '_clinics': [...form._clinics, {
        name: "",
        address: "",
        email: "",
        provider_number: ""
      }]
    })
  }

  const handleDeleteClinic = (i) => {
    var clinics = form._clinics.filter((value, index) => index !== i);
    setForm({
      ...form,
      '_clinics': clinics
    })
}

  const handleCheckbox = (e, checkbox) => {
    let checkbox_arr = [];
    if(e.target.checked){
      checkbox_arr = [...form[checkbox], e.target.name]
    }
    else{
      checkbox_arr = form[checkbox].filter(item => item !== e.target.name)
    }
    setForm({
      ...form,
      [checkbox]: checkbox_arr
    });
  }

  const backStep = () => {
    G.RESET_SCROLL();
    setCurrentStep(currentStep - 1)
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if(currentStep < totalSteps){
      if(currentStep <= 3 ){
        dispatch(registerValidate({step: currentStep, data: form})).then(e => {
          G.RESET_SCROLL();
          if(e.payload){
            dispatch(resetErrors());
            setCurrentStep(currentStep + 1);
          }
          else{
            setCurrentStep(currentStep);
          }
        });
      }
      else{
        G.RESET_SCROLL();
        setCurrentStep(currentStep + 1);
      }
      
    }
    else{
      dispatch(register(form));
    }
    

    // setState(initialFormState);
  };
  useEffect(() => {
    //empty previous errors from redux
    dispatch(resetErrors());
  }, [dispatch]);

  // useEffect(() => {
  //   if(errors){
  //     setCurrentStep(1);
  //   }
  // }, [errors])

  return (
    <>
    <PageHead 
      className="page-register--head"
      title="Register a new account"
    />
    <PageContent className="page-register--content">
      {errors && errors.length > 0 ? 
        <div className="form-errors">
          {errors.map((error, index) => (
            <div key={index} className="form-errors--item">{error.message}</div>
          ))}
        </div> 
      : null}
      <div className="page-register--subtitle">Step {currentStep} of {totalSteps}</div>
      <form onSubmit={handleSubmit}>
        <Step step={1} currentStep={+currentStep}>
          <h2><Word value="Account details" /></h2>
          <Select
            type={"text"}
            name={"_salutation"}
            title={"Salutation"}
            options={G.SALUTATIONS_OPTIONS}
            value={form._salutation ? ({label: form._salutation, value: form._salutation}) : null}
            onChange={(payload) => handleSelectChange('_salutation', payload)}
            isRequired
          />
          <Input
            type={"text"}
            name={"_first_name"}
            title={"First name"}
            value={form._first_name}
            handleChange={handleChange}
            isRequired
          />
          <Input
            type={"text"}
            name={"_last_name"}
            title={"Last name"}
            value={form._last_name}
            handleChange={handleChange}
            isRequired
          />
          <Input
            type={"email"}
            name={"_email"}
            title={"Email"}
            value={form._email}
            handleChange={handleChange}
            isRequired
          />
          <InputPhone
            name={"_mobile_number"}
            title={"Mobile"}
            value={form._mobile_number}
            handleChange={handleChange}
            isRequired
          />
          <Input
            type={"number"}
            name={"_postcode"}
            title={"Postcode"}
            value={form._postcode}
            handleChange={handleChange}
            isRequired
          />
          <Input
            type={"password"}
            name={"_pass"}
            title={"Password"}
            value={form._pass}
            handleChange={handleChange}
            isRequired
            autoComplete="new-password"
            pattern=".{8,}"
          /> 
          <div className="form-actions">
            <Button
              type={"submit"}
              className="btn btn-primary btn-blue text-yellow full-width"
              text="Next"
            />
          </div>
          
          <div className="form-text-link"><Word value="Already have an account?" />&nbsp;<Link to="/login"><Word value="Log in" /></Link></div>
        </Step>
        <Step step={2} currentStep={+currentStep}>
          <h2><Word value="Professional details" /></h2>
          {specialities && Object.values(specialities).length > 0 ? 
            <>
              <Select 
                title={'Speciality'}
                name={'_speciality'}
                options={Object.values(specialities)}
                onChange={handleSpecialityChange}
                value={form._speciality ? ({label: specialities[form._speciality].label, value: form._speciality}) : null}
                isRequired
              />
              <Select 
                title={'Sub Speciality'}
                name={'_sub_specialities'}
                options={subSpecialities}
                onChange={(payload) => handleSelectChange('_sub_specialities', payload, true)}
                value={form._sub_specialities ? form._sub_specialities.map(item => ({label: item, value: item})) : null}
                isMulti
                isRequired
              />
            </>
          : null}
          <Input
            type={"text"}
            name={"_ahpra_number"}
            title={"AHPRA Number"}
            value={form._ahpra_number}
            handleChange={handleChange}
            isRequired
            pattern="^[a-zA-Z]{3}\d{10}"
          />
          <Input
            type={"text"}
            name={"_racgp_number"}
            title={"RACGP Number"}
            value={form._racgp_number}
            handleChange={handleChange}
          />
          <div className="form-actions">
            <Button
              type={"submit"}
              className="btn btn-primary btn-blue text-yellow full-width"
              text="Next"
            />
            <Button
              type={"button"}
              className="btn btn-outline full-width"
              text="Back"
              Clicked={backStep}
            />
          </div>
        </Step>
        <Step step={3} currentStep={+currentStep}>
          <h2><Word value="Practice details" /></h2>
          {form._clinics.map((clinic, index) => (
            <div key={index} className={`form-container${index > 0 ? ' has-close' : ''}`}>
              {index > 0 ? <div className="form-container--close" onClick={() => handleDeleteClinic(index)}><CloseIcon /></div> : null}
              <Input
                type={"text"}
                name={"name"}
                title={"Clinic name"}
                value={clinic.name}
                handleChange={(e) => handleChangeClinic(e, index)}
                isRequired
              />
              <Input
                type={"text"}
                name={"address"}
                title={"Clinic address"}
                value={clinic.address}
                handleChange={(e) => handleChangeClinic(e, index)}
                isRequired
              />
              <Input
                type={"email"}
                name={"email"}
                title={"Clinic email"}
                value={clinic.email}
                handleChange={(e) => handleChangeClinic(e, index)}
                isRequired
              />
              <Input
                type={"text"}
                name={"provider_number"}
                title={"Provider number"}
                value={clinic.provider_number}
                handleChange={(e) => handleChangeClinic(e, index)}
                isRequired
              />
            </div>
          ))}
          {form._clinics.length < G.CLINICS_ALLOWED_NB ? 
            <Button 
              className="btn-plain blue add-btn"
              text="+ Add another clinic"
              Clicked={handleAddClinic}
            />
          : null}
          <div className="form-actions">
            <Button
              type={"submit"}
              className="btn btn-primary btn-blue text-yellow full-width"
              text="Next"
            />
            <Button
              type={"button"}
              className="btn btn-outline full-width"
              text={<Word value="Back" />}
              Clicked={backStep}
            />
          </div>
        </Step>
        <Step step={4} currentStep={currentStep}>
          <h2><Word value="Preferences" /></h2>
          <div className="page-register--text">Please select your interest areas to  personalise your education recommendations</div>
          {topics && topics.length > 0 ?
            topics.map((topic, index) => {
              return <Checkbox
                      key={index}
                      title={topic.name}
                      name={topic.slug}
                      handleChange={(e) => handleCheckbox(e, '_topics')}
                    />
            })
          : null}
          <div className="form-actions sticky">
            <Button
              type={"submit"}
              className="btn btn-primary btn-blue text-yellow full-width"
              text="Next"
            />
            <Button
              type={"button"}
              className="btn btn-outline full-width"
              text={<Word value="Back" />}
              Clicked={backStep}
            />
          </div>
        </Step>
        <Step step={5} currentStep={currentStep}>
          <h2><Word value="Marketing" /></h2>
          <div className="page-register--text">Please select your email marketing preferences</div>
          {G.MARKETING_OPTIONS && G.MARKETING_OPTIONS.length > 0 ?
            G.MARKETING_OPTIONS.map((option, index) => {
              return <Checkbox
                      key={index}
                      title={option.label}
                      name={option.value}
                      handleChange={(e) => handleCheckbox(e, '_marketing')}
                    />
            })
          : null}
          <div className="form-actions sticky">
            <Button
              type={"submit"}
              className="btn btn-primary btn-blue text-yellow full-width"
              text="Register"
            />
            <Button
              type={"button"}
              className="btn btn-outline full-width"
              text={<Word value="Back" />}
              Clicked={backStep}
            />
          </div>
        </Step>
      
      </form>
    </PageContent>
    </>
  );
};

export default RegisterForm;